// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Redux
// import { removeReducers } from 'store/reducers'

// Hocs
import { connect } from 'react-redux'
import withViewport from 'hocs/withViewport'

// Action Creators
// import { push } from 'react-router-redux'
// import { toggleAppMenu } from 'data/navigation'

// Selectors
// import isBooting$ from 'data/auth/selectors/isBooting'
// import isAuthenticated$ from 'data/auth/selectors/isAuthenticated'
import token$ from 'fc-auth/src/selectors/token'
// import location$ from 'data/navigation/selectors/location'

// Components
// import LoadingScreen from 'components/masks/LoadingScreen'

// Localization
import { FormattedMessage } from 'react-intl'
import messages from './messages'

// Local
function mapStateToProps (state) {
  return {
    // isAuthenticated: isAuthenticated$(state),
    // isBooting: isBooting$(state),
    token: token$(state),
    // location: location$(state),
  }
}

const mapDispatchToProps = {
  // push,
  // toggleAppMenu,
}

// Exports
export default function asyncRoute ({ getComponent, reducers = [] }) {
  class AsyncRoute extends Component {
    constructor () {
      super()

      this.state = {
        AsyncComponent: null,
        error: null,
        errorInfo: null,
      }
    }

    componentDidMount () {
      this.getComponent()
    }

    componentDidCatch (error, errorInfo) {
      this.setState({
        error,
        errorInfo,
      })
    }

    componentWillUnmount () {
      if (reducers.length) {
        // const store = this.props.store || this.context.store
        // removeReducers(store, ...reducers)
      }
    }

    getComponent () {
      const store = this.props.store || this.context.store
      getComponent({store}).then((AsyncComponent) => {
        this.setState({
          AsyncComponent,
        })
      })
    }

    render () {
      const { AsyncComponent, error, errorInfo } = this.state
      if (error) {
        const isDevMode = __DEV__
        const support_email = (
          <a href='mailto:agphd.helpdesk@farmersedge.ca'>
            <FormattedMessage {...messages['support_email']} />
          </a>
        )
        const clientMsg = (
          <div>
            <FormattedMessage {...messages['prod_react_error_msg1']} /> {support_email}
            <FormattedMessage {...messages['prod_react_error_msg2']} />
          </div>
        )
        return (
          <div style={{padding: 15}}>
            <h1>
              <FormattedMessage {...messages['prod_react_error_title']} />
            </h1>
            <h2>
              <FormattedMessage {...messages['prod_react_error_subtitle']} />
            </h2>
            <p style={{padding: 10}}>
              {isDevMode ? error && error.toString() : clientMsg}</p>
            {isDevMode && (
              <details style={{whiteSpace: 'pre-wrap', fontSize: '0.9rem'}}>
                {errorInfo.componentStack}
              </details>
            )}
          </div>
        )
        // Send error to crash analytics tracker
      }

      if (AsyncComponent) {
        return (
          <AsyncComponent
            // mediaQueryMatch={this.props.viewport.width >= 800}
            // params={this.props.match.params}
            {...this.props}
          />
        )
      }

      return null
      //  (
      // <LoadingScreen />
      // )
    }
  }

  AsyncRoute.propTypes = {
    store: PropTypes.object,
  }

  AsyncRoute.contextTypes = {
    store: PropTypes.object,
  }

  return connect(mapStateToProps, mapDispatchToProps)(withViewport(AsyncRoute))
}
